import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonInnerFn = /* @__PURE__ */ createRecipe('button-inner', {}, [])

const buttonInnerVariantMap = {}

const buttonInnerVariantKeys = Object.keys(buttonInnerVariantMap)

export const buttonInner = /* @__PURE__ */ Object.assign(memo(buttonInnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonInner',
  __getCompoundVariantCss__: buttonInnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonInnerVariantKeys,
  variantMap: buttonInnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonInnerVariantKeys)
  },
  getVariantProps: buttonInnerFn.getVariantProps,
})